import { TriangleAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function StrandedGetImmediateHelp() {
  return <section data-section-id="141165" id="minimize-your-downtime" className="dark bg-background text-foreground py-16 px-4 sm:px-6 lg:px-8">
      <style>{`
        @keyframes faulty-neon {
          0%, 19.999%, 22%, 62.999%, 64%, 64.999%, 70%, 100% { opacity: 1; filter: drop-shadow(0 0 15px rgba(0,0,0,0.4)); }
          20%, 21.999%, 63%, 63.999%, 65%, 69.999% { opacity: 0.3; filter: drop-shadow(0 0 2px rgba(0,0,0,0.1)); }
        }
        .animate-faulty-neon {
          animation: faulty-neon 4s infinite;
        }
      `}</style>

      <div className="relative max-w-6xl mx-auto overflow-hidden rounded-sm border border-primary/20 shadow-2xl">
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-primary to-[hsl(35,100%,60%)]" />
        
        {}
        <div className="absolute inset-0 bg-[linear-gradient(transparent_50%,rgba(0,0,0,0.1)_50%)] bg-[length:100%_4px] pointer-events-none mix-blend-overlay" />
        
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.2)_100%)] pointer-events-none" />

        <div className="relative z-10 flex flex-col items-center justify-center py-20 px-4 text-center">
          {}
          <div className="mb-8 animate-faulty-neon">
            <TriangleAlert className="w-20 h-20 text-black" strokeWidth={2} />
          </div>

          {}
          <h2 className="text-5xl md:text-7xl font-black text-black tracking-tighter mb-10 uppercase drop-shadow-[0_2px_4px_rgba(0,0,0,0.1)] font-sans">
            Minimize Your Downtime
          </h2>

          {}
          <Button asChild size="lg" className="bg-black text-primary hover:bg-black/90 hover:text-primary text-3xl md:text-4xl font-black py-10 px-12 rounded-sm shadow-[0_10px_40px_rgba(0,0,0,0.3)] transition-all duration-300 hover:shadow-[0_15px_60px_rgba(0,0,0,0.4)] hover:scale-105 border-2 border-transparent hover:border-black/50 font-mono tracking-tight">
            <Link to="/RequestServicePage">
              START REPAIR TICKET
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}